import {makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import Feature from "../../Feature";

export default class AuthorizationDeliverySiteOnboardingFeature extends Feature {

    constructor(application, deliverySiteOnboardingId, showFiscalProfile = true) {
        super(application);
        this._deliverySiteOnboardingId = deliverySiteOnboardingId;
        this._showFiscalProfile = showFiscalProfile;
        this._taxpayerIdentificationNumber = null;
        this._cm01Form = {name: null, url: null};
        this._cm05Form = {name: null, url: null};

        makeObservable(this, {
            _cm01Form: observable,
            _cm05Form: observable,
        });
    }

    async load() {
        if (this._showFiscalProfile) {
            await this._loadCustomerTaxpayerIdentificationNumber();
            if (this._taxpayerIdentificationNumber) {
                await this._loadFiscalProfile();
            }
        }
        this.finishLoading();
    }

    async _loadCustomerTaxpayerIdentificationNumber() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._taxpayerIdentificationNumber = response.deliverySiteOnboarding().customer.taxpayerIdentificationNumber;
            },
            handlesError: () => {}
        });
        return this._application.apiClient().getDeliverySiteOnboarding(this._deliverySiteOnboardingId, responseHandler);
    }

    async _loadFiscalProfile() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this._cm01Form = response.cm01Form();
                this._cm05Form = response.cm05Form();
            },
            handlesError: () => {
                handleErrorToast("No se pudo obtener la información del cm01 o cm05.");
            }
        });
        return this._application.apiClient().grossIncomeTaxProfileOfCustomer(responseHandler, this._taxpayerIdentificationNumber);
    }

    cm01Form() {
        return this._cm01Form;
    }

    cm05Form() {
        return this._cm05Form;
    }
}
